/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  createApi,
  fetchBaseQuery,
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
} from "@reduxjs/toolkit/query/react";
import type { RootState } from "../app/store";
import { resetAuth } from "../reducers/authSlice";
import { generateEncryptedKeyBody, generateSEKAndHash } from "./crypto";
import { API_URL } from "../constants/url";
import { showToast } from "../constants/toasts";
import { STORAGE_KEYS } from "../constants/storageKeys";
import { getFromStorage } from "../helpers/storage";

const baseQuery = fetchBaseQuery({
  baseUrl: API_URL,
  prepareHeaders: (headers, { getState }) => {
    // const { token } = (getState() as RootState).auth;
    const token = getFromStorage(STORAGE_KEYS.token);
    const { tempToken } = (getState() as RootState).auth;

    const encryptData = generateSEKAndHash(token || tempToken || null);

    if (encryptData) {
      const rawToken = (token || tempToken || "").toString().trim();
      let sanitizedToken = rawToken.replace(/Authorization:\s*/gi, "").trim();
      sanitizedToken = sanitizedToken.replace(/^(Bearer\s*)+/gi, "").trim();
      const bearerToken = sanitizedToken ? `Bearer ${sanitizedToken}` : "";

      if (bearerToken) headers.set("Authorization", bearerToken);
      headers.set("hash", encryptData?.hash);
      headers.set("sek", encryptData?.sek);
      headers.set("x-device-type", "WEB");
      headers.set("x-portal", "ADMIN");
      headers.set("date", new Date().toISOString());
    }

    return headers;
  },
});

const baseQueryWithAuth: BaseQueryFn<
  string | FetchArgs | any,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  console.log("RTK API call:", args.url);

  // if (args?.body) {
  //   body = generateEncryptedKeyBody(args?.body); // Encrypt request body if it exists
  // }

  // Define data object based on presence of request body
  const result = await baseQuery(args, api, extraOptions);

  if (result.error?.status === 400) {
    const errors = Object.values(result?.error?.data || {});
    console.log(errors);

    if (errors?.length > 1 && errors[1] === 400) {
      return result;
    }
    if (errors?.length) {
      const error = errors[0] as any;
      if (error?.length) {
        console.log(error[0]);
      }
    }
  }
  if (result?.error?.status === 401) {
    console.log("401 error - resetting auth");
    api.dispatch(resetAuth());
    if (window) {
      window.location.replace("/");
    }
  }
  if (
    result.error &&
    result.error.status === 401 &&
    (api.getState() as RootState).auth.user
  ) {
    console.log("401 error with user - resetting auth");
    api.dispatch(resetAuth());
  }

  return result;
};

const api = createApi({
  baseQuery: baseQueryWithAuth,
  tagTypes: [
    "UNAUTHORIZED",
    "UNKNOWN_ERROR",
    "ADBANNER",
    "CMS",
    "DISCOUNT",
    "SERVICEMANAGEMENT",
  ],
  endpoints: () => ({}),
});

export default api;
